import { FC, useState } from 'react'
import { TextInput } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { IconButton, InputAdornment } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

const MASK = '***'

interface SecretRevealInputProps {
  source: string
  label: string
  helperText?: string
  onReveal: () => Promise<string | null>
}

export const SecretRevealInput: FC<SecretRevealInputProps> = ({
  source, label, helperText, onReveal,
}) => {
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const { getValues, setValue } = useFormContext()

  const handleToggle = async () => {
    if (visible) {
      setVisible(false)
      return
    }
    if (getValues(source) === MASK) {
      setLoading(true)
      try {
        const real = await onReveal()
        if (real !== null) setValue(source, real, { shouldDirty: false })
      } finally {
        setLoading(false)
      }
    }
    setVisible(true)
  }

  return (
    <TextInput
      source={source}
      label={label}
      helperText={helperText}
      type={visible ? 'text' : 'password'}
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              edge="end"
              disabled={loading}
              onClick={() => { void handleToggle() }}
            >
              {visible
                ? <VisibilityOffIcon sx={{ fontSize: 18, color: 'rgba(0,0,0,0.4)' }} />
                : <VisibilityIcon sx={{ fontSize: 18, color: 'rgba(0,0,0,0.4)' }} />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
